function toggleAccordion() {
  const Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    const links = this.el.find('.panel-heading');
    // Evento
    links.on('click', { el: this.el, multiple: this.multiple }, this.dropdown);
  };

  Accordion.prototype.dropdown = function(e) {
    const $el = e.data.el;
    const $this = $(this);
    const $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('active');

    // TODO
    // triggerScroll($this.parent());

    if (!e.data.multiple) {
      $el.find('.panel-collapse').not($next).slideUp().parent()
      .removeClass('active');
    }
  };

  const $accordion = new Accordion($('.js-accordion-section'));

  if (!$accordion.length) {
    return;
  }
}

// TODO
// function triggerScroll(element) {
//   if (element.hasClass('active')) {
//     const padding = 20;
//     const to = element.offset().top - padding;

//     $({ scrollTop: window.scrollY }).animate({ scrollTop: to }, {
//       duration: 600,
//       easing: 'swing',
//       step: function(val) {
//         window.scrollTo(0, val);
//       },
//     });
//   }
// }

export default { toggleAccordion };



// WEBPACK FOOTER //
// ./src/js/custom/accordion.js